import React from 'react';
import './styles.scss';
import { TeamMemberType } from './types';
import LinkedIn from 'assets/LinkedIn';
import Twitter from 'assets/Twitter';
import Mail from 'assets/Mail';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const TeamMember = (props: TeamMemberType) => {
  const { name, jobTitle, avatar, linkedinURL, twitterURL, email, children } = props;
  return (
    <div className="__team-member d-lg-flex align-items-center">
      <div className="__image-wrapper">
        <LazyLoadImage src={avatar} alt="" className="__profile-image" />
        <div className="d-flex align-items-center justify-content-center __primary-text-color __social-links">
          {linkedinURL && (
            <a href={linkedinURL} target="__blank">
              <LinkedIn />
            </a>
          )}
          {/*{twitterURL && (
            <a href={twitterURL} target="__blank">
              <Twitter />
            </a>
          )}*/}
          {email && (
            <a href={`mailto:${email}`} target="__blank">
              <Mail />
            </a>
          )}
        </div>
      </div>
      <div className="__team-details">
        <h4 className="font_montserrat font-weight-mediam-bold __title m-0 __primary-text-color">{name}</h4>
        <h6 className="__subtitle font_lato font-weight-bold">{jobTitle}</h6>
        <p className="team-member-description">{children}</p>
      </div>
    </div>
  );
};

export default TeamMember;
